class Colors {
  static blueText = '#0057b8';
  static textColor = '#536583';
  static textColor2 = '#9baac2';
  static smallTitle = '#4b5563';

  static approveText = '#22c55e';
  static approveText2 = '#28a745';
  static warningText = '#f97316';
  static warningYelloText = '#ffc107';
  static dangerText = '#ef4444';
  static dangerText2 = '#dc3545';
  static lightApprove = '#6bdc94';

  static expectedIncomesBackground = 'rgba(34, 197, 94, 0.2)';
  static expectedIncomesBorder = '#79e7a2';

  static actualIncomesBackground = 'rgba(16, 185, 129, 0.2)';
  static actualIncomesBorder = '#10b981';

  static expectedExpensesBackground = 'rgba(239, 68, 68, 0.2)';
  static expectedExpensesBorder = '#ef4444';

  static actualExpensesBackground = 'rgba(249, 115, 22, 0.2)';
  static actualExpensesBorder = '#f97316';
}
export default Colors;

/*return '#594ade';*/
